import {
    LOAD_MARKETING_AUTOMATIONS,
    LOAD_MARKETING_AUTOMATIONS_DISABLED,
    LOAD_CUSTOMER_AUTOMATION_SEARCH,
    BLOCK_UNBLOCK_CUSTOMER,
    CHECK_ADD_CUSTOMER,
    ADD_CUSTOMER,
    CLEAR_CUSTOMER_TO_ADD
} from '../../actions/types';

const INITIAL_STATE = {
    triggers: [],
    marketingAutomationEnabled: null,
    customers: {},
    customerToAdd: {},
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_MARKETING_AUTOMATIONS:
            return {
                triggers: action.payload,
                marketingAutomationEnabled: true
            }
        case LOAD_MARKETING_AUTOMATIONS_DISABLED:
            return {
                triggers: state.triggers,
                marketingAutomationEnabled: false
            }
        case LOAD_CUSTOMER_AUTOMATION_SEARCH:
            return {
                customers: action.payload
            }
        case BLOCK_UNBLOCK_CUSTOMER: 
            const editedCustomersContent = state.customers.content.map((item) => item.id === action.payload.id ? action.payload : item);
            return {
                customers: {
                    ...state.customers,
                    content: editedCustomersContent
                }
            }
        case CHECK_ADD_CUSTOMER:
            return {
                ...state,
                customerToAdd: action.payload
            }
        case ADD_CUSTOMER:
            const editedCustomers = state.customers.content;
            editedCustomers.push(action.payload);
            return {
                customers: {
                    ...state.customers,
                    content: editedCustomers
                }
            }
        case CLEAR_CUSTOMER_TO_ADD: 
            return {
                ...state,
                customerToAdd: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/marketingAutomations/MarketingAutomationsReducer.js